// extracted by mini-css-extract-plugin
module.exports = {"slide":"slide___3wMGt","imageArea":"imageArea___1JMLj","widthPriorityImage":"widthPriorityImage___2Lidl","active":"active___1hCKH"};